import React from 'react'
import { connect } from 'react-redux'
import './index.scss'
import { closeModal } from '../../../action/positioned-modal-state'
import isNil from 'lodash/isNil'
import HuntModal from './hunt-modal'
import SubscriptionInfo from './subscription-info'
import Payment from './payment'
import UpgradeModal from './upgrade-modal'
import { collapseLeftToolbar } from '../../../action/left-toolbar-state-actions'
import { collapseRightToolbar } from '../../../action/right-toolbar-state-actions'
import { showHideSubscriptionModal } from '../../../utils/subscriptionUtils'

class PositionedModal extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    const { positionedModal, collapseLeftToolbar, collapseRightToolbar, closeModal, accessToken } = this.props
    if (positionedModal.data.subInfo || !isNil(positionedModal.data.payment)) {
      collapseLeftToolbar()
      collapseRightToolbar()
    }
    if (positionedModal.data.subInfo) {
      showHideSubscriptionModal(accessToken, closeModal)
    }
  }



  render() {
    const { positionedModal, closeModal } = this.props
    return (
      <div onClick={closeModal}
        className='positioned-modal-container'>
        {
          positionedModal.data.subInfo ? null :
            !isNil(positionedModal.data.payment) ? <Payment /> :
              !isNil(positionedModal.data.harvest_data) ? <HuntModal /> :
                !isNil(positionedModal.data.upgrade) ? <UpgradeModal /> : null
        }
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    positionedModal: state.positionedModal,
    accessToken: state.auth.token
  }
}

const mapDispatchToProps = dispatch => ({
  collapseLeftToolbar: () => dispatch(collapseLeftToolbar()),
  collapseRightToolbar: () => dispatch(collapseRightToolbar()),
  closeModal: () => dispatch(closeModal())
})

export default connect(mapStateToProps, mapDispatchToProps)(PositionedModal)
